/**
 * Маппинг кода валюты (ISO 4217) в символ для отображения
 *
 * Валюта привязана к конкретному желанию, а не к языку приложения.
 * Пользователь может использовать приложение на английском, но цены — в рублях.
 */

/** Словарь символов валют */
const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  RUB: '₽',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  KRW: '₩',
  INR: '₹',
  BRL: 'R$',
  CAD: 'C$',
  AUD: 'A$',
  NZD: 'NZ$',
  CHF: 'CHF',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  TRY: '₺',
  UAH: '₴',
  KZT: '₸',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  MXN: 'MX$',
  SGD: 'S$',
  HKD: 'HK$',
  THB: '฿',
  ZAR: 'R',
} as const;

/**
 * Получить символ валюты по ISO-коду
 *
 * @param currencyCode — код валюты (например, 'RUB', 'USD')
 * @returns символ валюты ('₽', '$', '€', '£') или сам код, если символ неизвестен
 *
 * @example
 * getCurrencySymbol('RUB')       // '₽'
 * getCurrencySymbol('USD')       // '$'
 * getCurrencySymbol(undefined)   // '$'  (fallback — дефолт стора USD)
 * getCurrencySymbol('JPY')       // '¥'
 */
export function getCurrencySymbol(currencyCode?: string | null): string {
  if (!currencyCode) return CURRENCY_SYMBOLS.USD;
  return CURRENCY_SYMBOLS[currencyCode] ?? currencyCode;
}